import { httpClient } from '@/infra/protocols/http';
import { IScriptDTO } from '@/modules/scripts/dtos/script.dto';
import { IScript } from '@/modules/scripts/entities/script.entity';
import { ScriptMapper } from '@/modules/scripts/mappers/script.mapper';

type EnrichedPrompt = {
  goal?: string;
  topic?: string;
  audience?: string;
  closingText?: string;
  openingText?: string;
};

export async function generateScript(
  params: GenerateScriptService.Params,
  data: GenerateScriptService.Payload,
): Promise<GenerateScriptService.Response> {
  const { audience, topic, goal, openingText, closingText } = data.enrichedPrompt;

  const contexto = {
    objetivo: goal,
    temaCentral: topic,
    publicoAlvo: audience,
    textoAbertura: openingText,
    textoFechamento: closingText,
  };

  const body = {
    contexto,
    url: data.url,
    prompt: data.prompt,
    conteudoTexto: data.text,
  };

  const response = await httpClient.post<IScriptDTO[]>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/roteiro/gerar`,
    body,
  );

  return response.map(ScriptMapper.toPresentation);
}

export namespace GenerateScriptService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
  }

  export type Payload = {
    text?: string;
    url?: string[];
    prompt?: string;
    files?: string[];
    enrichedPrompt: EnrichedPrompt;
  };

  export type Response = IScript[];
}
